import type { Locale } from "@/lib/i18n";
import { pl, type CatalogLoadMoreTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const catalogLoadMoreTranslations: Record<Locale, CatalogLoadMoreTranslations> = {
  pl,
  en,
  de,
};

export type { CatalogLoadMoreTranslations };
